import { gql, useMutation } from '@apollo/client';
import { useState } from 'react';

const INITIATE_PAYMENT = gql`
   mutation InitiatePayment($oopId: ID!, $method: String!, $paymentDetails: PaymentDetailsInput!) {
      initiatePayment(oopId: $oopId, method: $method, paymentDetails: $paymentDetails) {
         id
         status
         amount
         paymentMethod
         createdAt
         expiresAt
      }
   }
`;

export const usePaymentProcess = (oopId) => {
   const [currentStep, setCurrentStep] = useState(1);
   const [paymentMethod, setPaymentMethod] = useState('');
   const [formData, setFormData] = useState({
      fullName: '',
      email: '',
      phoneNumber: '',
      address: '',
   });

   const [initiatePayment] = useMutation(INITIATE_PAYMENT);

   const handlePayment = async () => {
      try {
         const { data: initiateData } = await initiatePayment({
            variables: {
               oopId,
               method: paymentMethod,
               paymentDetails: {
                  fullName: formData.fullName,
                  email: formData.email,
                  phoneNumber: formData.phoneNumber,
                  address: formData.address
               }
            },
            refetchQueries: ['GetOOPDetails']
         });

         if (initiateData?.initiatePayment) {
            if (paymentMethod === 'MANUAL') {
               return {
                  success: true,
                  message: 'Manual payment initiated successfully'
               };
            }

            return initiateData.initiatePayment;
         }
      } catch (error) {
         console.error('Payment processing error:', error);
         throw error;
      }
   };

   const nextStep = () => setCurrentStep(prev => prev + 1);
   const prevStep = () => setCurrentStep(prev => prev - 1);

   return {
      currentStep,
      formData,
      paymentMethod,
      setFormData,
      setPaymentMethod,
      nextStep,
      prevStep,
      handlePayment
   };
};
